<template>
  <div class="educa_manage_wrap" v-loading="loading" :style="'height:'+(windowHeight-95)+'px'">
    <div class="educa_manage_header">
      <h2>学校logo</h2>
    </div>
    <div class="educa_manage_content">
      <div class="school_logo_main">
        <div class="upload_wrap">
          <el-upload
            class="avatar-uploader"
            :action="uploadSrc"
            :show-file-list="false"
            accept=".png"
            :data="uploadData"
            :headers="headers"
            :disabled="isDisabled"
            :on-progress="handleAvatarProgress"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload" v-model="pic">
            <img v-if="pic" :src="pic" class="avatar">
            <i v-else :class="uploadIcon"></i>
            <!--<p v-if="pic" class="updata_logo"><i class="el-icon-edit"></i></p>-->
          </el-upload>
          <div v-if="pic" class="upload_delete" @click="deleteUpload">
            <i class="el-icon-error"></i>
          </div>
        </div>
        <div class="upload_tips">
          <p><i>*</i>注意：</p>
          <p>1.仅支持png格式</p>
          <p>2.推荐尺寸：高度40px，长度320px以内</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import * as api from '@/api/educationalApi'
  export default {
    data() {
      return {
        loading: true,
        pic: '',
        uploadIcon: 'el-icon-plus avatar-uploader-icon',
        isDisabled: false,
        schoolImg: '',
        deptId: sessionStorage.getItem('deptId'),
        uploadSrc: `${process.env.UPLOAD_NAME}/file/uploadImage`,
        windowHeight: window.innerHeight
      }
    },
    computed: {
      uploadData(){
        return {
          "savepath":"cjdd/course/logo"
        }
      },
      headers(){
        return {
          "Authorization": "bearer "+localStorage.getItem('Authorization')
        }
      }
    },
    created() {
      this.loading = false
      this.getInfo()
    },
    methods: {
      getInfo(){
        api.getDeptInfo(this.deptId).then(rs=>{
          if(rs.code==0){
            if(rs.data.deptLogo&&rs.data.deptLogo!=""){
              this.pic=rs.data.deptLogo
            }else{
              this.pic=""
            }
          }else{
            this.$messageError(rs.msg)
          }
        }).catch(err=>{
          console.log(err)
        })
      },
      //上传图片
      handleAvatarSuccess(res, file) {
        let that = this
        this.pic = URL.createObjectURL(file.raw);
        this.schoolImg = res.data.imagePath
        this.uploadIcon = 'el-icon-plus avatar-uploader-icon'
        let obj = {
          deptId: this.deptId,
          deptLogo: this.schoolImg
        }
        api.updateDeptLogo(obj).then(rs=>{
          if(rs.code==0){
            this.$messageSuccess('上传成功')
          }else{
            this.$messageError(rs.msg)
          }
        }).catch(err=>{
          console.log(err)
        })
      },
      handleAvatarProgress(){
        let that = this
        this.pic = '';
        this.uploadIcon = 'el-icon-loading avatar-uploader-icon'
      },
      beforeAvatarUpload(file) {
        this.uploadIcon = 'el-icon-loading avatar-uploader-icon'
        let png = file.type === 'image/png'
        const isJPG = png;
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$messageError('上传logo仅限 PNG 格式!');
          this.uploadIcon = 'el-icon-plus avatar-uploader-icon'
        }
        if (!isLt1M) {
          this.$messageError('上传logo大小不能超过 1MB!');
          this.uploadIcon = 'el-icon-plus avatar-uploader-icon'
        }
        return isJPG && isLt1M;
      },
      deleteUpload(){
        let obj = {
          deptId: this.deptId,
          deptLogo: ''
        }
        api.updateDeptLogo(obj).then(rs=>{
          if(rs.code==0){
            this.$messageSuccess('删除成功')
            this.pic = ''
          }else{
            this.$messageError(rs.msg)
          }
        }).catch(err=>{
          console.log(err)
        })
      }
    },
  }
</script>
<style lang="scss" scoped>
  .educa_manage_wrap{
    .educa_manage_content{
      padding-top: 100px;
      box-sizing: border-box;
    }
    /deep/ .school_logo_main{
      width:604px;
      height:288px;
      background:rgba(255,255,255,1);
      box-shadow:0px 0px 6px rgba(0,0,0,0.2);
      border-radius:8px;
      margin: auto;
      padding-top: 56px;
      box-sizing: border-box;
      .upload_wrap{
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        // overflow: hidden;
        margin: 0 0 0 102px;
        width:400px;
        height:100px;
        .updata_logo{
          width:400px;
          height:100px;
          position: absolute;
          left:-5px;
          top:-5px;
          background: rgba(0,0,0,0.6);
          opacity: 0;
          transition: opacity 0.8s;
          i{
            width: 20px;
            height: 20px;
            position: absolute;
            left:0;
            top:0;
            right:0;
            bottom:0;
            margin: auto;
            font-size: 20px;
            color: #fff;
          }
        }
        .upload_delete{
          width: 20px;
          height: 20px;
          position: absolute;
          right: -10px;
          top: -10px;
          z-index:99;
          i{
            font-size: 20px;
            color: #999;
          }
          &:hover{
            i{
              color: #333;
            }
          }
        }
        &:hover{
          border-color: #409EFF;
        }
      }
      .avatar-uploader{
        position: absolute;
        width: 390px;
        height: 90px;
        top:0;
        right:0;
        left:0;
        bottom:0;
        margin: auto;
        .el-upload{
          width: 100%;
          height: 100%;
        }
        &:hover{
          .updata_logo{
            opacity: 1;
          }
        }
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        height: 100%;
        line-height: 100px;
        text-align: center;
        position: absolute;
        top:0;
        right:0;
        left:0;
        bottom:0;
        margin: auto;
      }
      .avatar {
        max-width:100%;
        max-height:100%;
        background:rgba(255,255,255,1);
        border-radius:4px;
        position: absolute;
        left:0;
        top:0;
        right:0;
        bottom: 0;
        margin: auto;
      }
      .upload_tips{
        padding-top: 32px;
        box-sizing: border-box;
        p{
          width: 230px;
          text-align: left;
          margin:auto;
          font-size:10px;
          font-weight:400;
          line-height:16px;
          color:rgba(153,153,153,1);
          i{
            color:#E34646;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/logoManage/schoolLogo.vue